import React from 'react'
import { Icon } from '@iconify/react'
import { useTranslation } from 'react-i18next'
import './style.css'

const SectionCard = ({ icon, titleKey, children, className = '' }) => {
    const { t } = useTranslation()

    return (
        <div className={`section-card ${className}`}>
            <div className="profile-section-card-header">
                <Icon icon={icon} className="section-card-icon" />
                <h2 className="section-card-title">{t(titleKey)}</h2>
            </div>
            <div className="profile-section-card-body">
                {children}
            </div>
        </div>
    )
}

export default SectionCard

